module.exports = __webpack_public_path__ + "img/J.0fbd0e8f.webp";